<script>
import _ from 'lodash'
import documentValidationResponseCodesJson from '@/data/json/document-validation/documentValidationResponseCodes.json'
export default {
  props: {
    documentData: {
      type: Object
    }
  },
  data: vm => ({
    responseCodes: documentValidationResponseCodesJson,
    title: vm.$t('component.documentValidation.validationResultStatus.status.header'),
    subTitle: vm.$t('component.documentValidation.validationResultStatus.status.'
      + vm.documentData.documentValidationStatusMessage  ),
    adobeLink: vm.$t('component.documentValidation.validationResultStatus.adobe.link'),
    adobeLinkText: vm.$t( 'component.documentValidation.validationResultStatus.adobe.link.text')
  }),
  computed: {
    hasErrors() {
      return (this.documentData.validationResults.filter(result => !result.success).length > 0)
    },
    groupedByFileName() {
      return _.groupBy(
        this.documentData.validationResults.filter(
          validationResult => !validationResult.success
        ),
        'fileName'
      )
    }
  }
}
</script>
<template>
  <v-card flat class="pa-0">
    <v-card-text class="pa-0">
      <v-row>
        <v-col id="validation-status-title">
          {{ title }}<br />
          <span id="validation-status-subtitle" :class="hasErrors ? 'error--text' : 'primary--text'">{{
              subTitle
            }}</span>
        </v-col>
      </v-row>
      <div v-for="fileName in Object.keys(groupedByFileName)" :key="fileName">
        <span class="primary--text">{{
            fileName.replace(/_split_\d+/, '')
          }}</span>
        <v-row
          v-for="(validationResult, index) in groupedByFileName[fileName]"
          :key="index">
          <v-col cols="auto" class="pa-1 pl-4"
          ><v-icon color="error" medium>mdi-close</v-icon></v-col>
          <v-col class="pa-1 pl-3">
            <span
              id="validation-result-error-output-description"
              class="text--primary-2"
              :class="hasErrors ? 'error--text' : 'primary--text'">
              {{ $cms.get(responseCodes, validationResult.validationCode) }}
              <a
                v-if="
                  validationResult.validationCode ===
                  $enums.validationCode.FontIsNotEmbedded"
                :href="adobeLink"
                target="_blank"
                color="primary"
                small>
                {{ adobeLinkText }}
                <v-icon class="pb-1" small color="primary">
                  mdi-information-outline</v-icon>
              </a>
            </span>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>
